// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>14</span>&nbsp;&nbsp;Surely, you behold trouble and misery;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;you see it and take it into your own hand.<br> </p> </div></div>";
// Exports
module.exports = code;